// What a client is doing right now, sent with the presence heartbeat so staff (and their rep) can
// see it live: the page they're on (pages can name the exact thing, e.g. the product open on the
// order screen) and their order in progress (the draft the order screen keeps in this browser).
import { safeGet } from './storage.js';

let detail = null;
let notify = null;
let timer = null;

/** Pages call this with a more specific label ("Viewing Aero Trunk — Black"); null to clear. */
export function setPresenceDetail(label) {
  if (label === detail) return;
  detail = label;
  // Tell the heartbeat soon (debounced) so the dashboard updates without waiting 45s.
  presenceChanged();
}
/** Something else changed (e.g. their order in progress) — send a heartbeat soon. */
export function presenceChanged() {
  clearTimeout(timer);
  timer = setTimeout(() => notify?.(), 1500);
}
export const onPresenceChange = (fn) => {
  notify = fn;
};

const PAGES = [
  [/^\/$/, 'home', 'On their home page'],
  [/^\/catalog/, 'order', 'Browsing the catalogue'],
  [/^\/orders\/[^/]+/, 'orders', 'Looking at an order'],
  [/^\/orders/, 'orders', 'Looking at their orders'],
  [/^\/invoices/, 'invoices', 'Checking their invoices'],
  [/^\/promotions/, 'promotions', 'Looking at promotions'],
  [/^\/messages/, 'messages', 'In messages'],
  [/^\/account/, 'account', 'In account settings'],
];

/** { kind, label } for where the client is. */
export function pageInfo(pathname, search = '') {
  const hit = PAGES.find(([re]) => re.test(pathname));
  const kind = hit?.[1] || 'other';
  if (kind === 'order' && detail) return { kind, label: detail };
  if (kind === 'order') {
    const type = new URLSearchParams(search).get('type');
    if (type) return { kind, label: `Browsing ${type}` };
  }
  return { kind, label: hit?.[2] || 'On the platform' };
}

/** The biggest order in progress saved in this browser: { subtotal, units, lines } or null. */
export function draftSummary(role = 'CLIENT') {
  let best = null;
  try {
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (!k || !k.startsWith(`wholesale.orderDraft.${role}.`)) continue;
      const d = JSON.parse(safeGet(k) || 'null');
      if (!d?.lines?.length) continue;
      let subtotal = 0;
      let units = 0;
      for (const l of d.lines) for (const s of Object.values(l.sizes || {})) {
        subtotal += (Number(s.qty) || 0) * (Number(s.price) || 0);
        units += Number(s.qty) || 0;
      }
      if (units && (!best || subtotal > best.subtotal)) best = { subtotal: Math.round(subtotal * 100) / 100, units, lines: d.lines.length };
    }
  } catch {
    /* storage blocked — no cart info */
  }
  return best;
}
